import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import OutsideClickHandler from 'react-outside-click-handler'

import CoinCommunictyPng from '../../assets/img/coin-community.png'
import { toggleCoinPane } from '../../redux/actions/pageGlobal'

import RedeemSection from './RedeemSection'
import TaskSection from './TaskSection'
import GuideSection from './GuideSection'
import HistorySection from './HistorySection'

const CoinPaneComponent = () => {
  const dispatch = useDispatch()
  const histories = useSelector(state => state.coin.histories)

  const handleClose = () => {
    dispatch(toggleCoinPane())
  }

  return (
    <OutsideClickHandler onOutsideClick={handleClose}>
      <div className="coin-pane-component">
        <div className="pane-header">
          <div className="pane-title">
            Earned Genius Coins
          </div>
          <span className="close-icon" title="Close" onClick={handleClose}>
            &times;
          </span>
        </div>
        <div className="pane-body">
          <RedeemSection />
          <TaskSection histories={histories} />
          <GuideSection histories={histories} />
          <HistorySection histories={histories} />
        </div>
        <div className="pane-footer">
          <a href="https://www.facebook.com/groups/1095709597142657" target="_blank" rel="noopener noreferrer">
            Share your wins and ask questions in the community!
            <img src={CoinCommunictyPng} alt="sellder ad ecosystem" />
          </a>
        </div>
      </div>
    </OutsideClickHandler>
  )
}

export default CoinPaneComponent
